import React from 'react'

import { Collapse } from 'antd'
import { map, get } from 'lodash'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import gfm from 'remark-gfm'

const { Panel } = Collapse

const callback = () => {
  // console.log(key);
}

const CustomCollapse = ({ header, defaultActiveKey = '', collection, hostApi }) => {
  return (
    <div className="collpase__wrapper">
      <div className="collpase__header">
        <h3>{header}</h3>
      </div>

      <Collapse
        onChange={callback}
        bordered={false}
        defaultActiveKey={defaultActiveKey}
        expandIconPosition="right"
        className="custom-collapse"
      >
        {map(collection, (item) => (
          <Panel
            className="customCollapseItem"
            header={get(item, 'Question')}
            key={get(item, 'id')}
          >
            <ReactMarkdown
              remarkPlugins={[gfm]}
              rehypePlugins={[rehypeRaw]}
              // eslint-disable-next-line react/no-children-prop
              children={get(item, 'Answer')}
              transformImageUri={(src) => `${hostApi}${src}`}
            />
          </Panel>
        ))}
      </Collapse>
    </div>
  )
}

CustomCollapse.propTypes = {
  header: PropTypes.string.isRequired,
  defaultActiveKey: PropTypes.string,
  collection: PropTypes.string.isRequired,
  hostApi: PropTypes.func,
}

CustomCollapse.propTypes = {
  defaultActiveKey: () => null,
  hostApi: () => null,
}
export default CustomCollapse
